module.exports = __webpack_public_path__ + "img/hr-car-mask-4.a1f7ba77.png";